fx.ns("desktop.common.toolbar", class ToolBarText extends shared.stage.ToolBarAction{
    
    constructor(command, component, container)
    {
        super(command, component, container); 

        //this.height(35);
        //this.width(30);
        
    }

    get content()
    {
        let value = this.component[this.command.field];
        return "<div class='content " + (String(value).length > 2 ? "smaller" : "")+ "'>" + value + "</div>";
    }

    selectionChanged()
    {
        this.find(".label").innerHTML = this.content;//this.component[this.command.field];
    }

    /*create()
    {
        super.create();
        this._node.innerHTML = this.render();
    }*/

    onComponentDataUpdated()
    {
        this.node.innerHTML = this.render();
    }
    
    render()
    {
        return "<div class='label'>" + this.content + "</div>";
    }

    
});
